(function () {
  if (window.__recsInit) return;
  window.__recsInit = true;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function closeSizes(except) {
    document.querySelectorAll('[data-rec-sizes]').forEach(function (s) { if (s !== except) s.hidden = true; });
  }
  function add(id, plus, sizes) {
    if (!id) return;
    plus.disabled = true;
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function () {
        plus.textContent = '✓';
        plus.classList.add('is-done');
        if (sizes) sizes.hidden = true;
        var c = document.querySelector('.header__cart');
        if (c) c.click();
        setTimeout(function () { plus.textContent = '+'; plus.classList.remove('is-done'); }, 1800);
      })
      .catch(function () { alert('Der Artikel konnte nicht hinzugefügt werden.'); })
      .then(function () { plus.disabled = false; });
  }

  document.addEventListener('click', function (e) {
    var nav = e.target.closest('[data-rec-prev], [data-rec-next]');
    if (nav) {
      var wrap = nav.closest('[data-rec]');
      var tr = wrap && wrap.querySelector('[data-rec-track]');
      if (tr) tr.scrollBy({ left: (nav.hasAttribute('data-rec-next') ? 1 : -1) * tr.clientWidth * 0.8, behavior: 'smooth' });
      return;
    }
    var plus = e.target.closest('[data-rec-plus]');
    if (plus) {
      var direct = plus.getAttribute('data-rec-direct');
      if (direct) { add(parseInt(direct, 10), plus, null); return; }
      var s = plus.closest('.rc').querySelector('[data-rec-sizes]');
      closeSizes(s);
      s.hidden = !s.hidden;
      return;
    }
    var sz = e.target.closest('[data-rec-variant]');
    if (sz) {
      var card = sz.closest('.rc');
      add(parseInt(sz.getAttribute('data-rec-variant'), 10), card.querySelector('[data-rec-plus]'), card.querySelector('[data-rec-sizes]'));
      return;
    }
    closeSizes(null);
  });

  // Produktkarten am Handy: Punkte unter dem Wischbild
  function buildDots(slider) {
    if (slider.__dots) return;
    var n = slider.querySelectorAll('.card__slide').length;
    if (n < 2) return;
    var dots = document.createElement('div');
    dots.className = 'card__dots';
    for (var i = 0; i < n; i++) dots.appendChild(document.createElement('i'));
    slider.parentNode.appendChild(dots);
    slider.__dots = dots;
    dots.firstChild.classList.add('is-on');
  }
  function buildAll() { document.querySelectorAll('[data-card-slider]').forEach(buildDots); }
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-card-slider]') || !t.__dots) return;
    var idx = Math.round(t.scrollLeft / Math.max(t.clientWidth, 1));
    t.__dots.querySelectorAll('i').forEach(function (d, k) { d.classList.toggle('is-on', k === idx); });
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', buildAll); else buildAll();
  window.addEventListener('load', buildAll);
})();